<template>
  <div class="form-group">
    <input
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
      v-bind:value="value"
      type="range"
      class="custom-range"
      id="customRange1"
    />
    <input
      type="text"
      class="form-control"
      id="number"
      v-bind:value="value"
      @input="$emit('input', $event.target.value)"
    />
    
  </div>
</template>

<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
const numberMask = createNumberMask({
  prefix: '',
  suffix: ' %' // This will put the dollar sign at the end, with a space.
})
export default {
  name: "Transparency",
  inheritAttrs: false,
  props: {
    label: String,
    value: [String, Boolean, Array, Object, Number],
  },
  data() {
    return {
      numberMask: numberMask,
    };
  },
};
</script>

<style>
</style>